// Cards are fetched as real product-card.liquid markup, not rebuilt in JS.

(function () {
  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', class extends HTMLElement {
      connectedCallback() {
        this._loading = this.querySelector('[data-wishlist-loading]');
        this._list = this.querySelector('[data-wishlist-list]');
        this._grid = this.querySelector('[data-wishlist-grid]');
        this._toolbar = this.querySelector('[data-wishlist-toolbar]');
        this._empty = this.querySelector('[data-wishlist-empty]');
        this._shownCount = this.querySelector('[data-wishlist-shown-count]');

        this._shareButtons = Array.from(document.querySelectorAll('[data-wishlist-share]'));
        this._shareButtons.forEach(button => button.addEventListener('click', this._onShareClick.bind(this)));

        this._addedBanner = this.querySelector('[data-wishlist-added-banner]');

        // Swatch changed: redirect to PDP instead of adding a stale variant.
        this._list.addEventListener('click', (event) => {
          const swatch = event.target.closest('.product-card__tooltip-swatch');
          if (!swatch) return;

          const card = swatch.closest('product-card');
          if (!card) return;

          card.setAttribute('data-wishlist-swatch-changed', 'true');

          const label = card.querySelector('[data-simple-add-to-cart-label]');
          if (label && label.dataset.viewProductLabel) label.textContent = label.dataset.viewProductLabel;
        }, true);

        this._list.addEventListener('submit', (event) => {
          const card = event.target.closest('product-card');
          if (card && card.hasAttribute('data-wishlist-swatch-changed')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const link = card.querySelector('a[href*="/products/"]');
            if (link) window.location.href = link.href;
            return;
          }

          this._pendingAddedBanner = true;
        }, true);

        this._onCartChange = () => {
          if (!this._pendingAddedBanner) return;
          this._pendingAddedBanner = false;
          this._showAddedBanner();
        };
        document.addEventListener('cart:change', this._onCartChange);

        this._onChange = (event) => {
          if (event.detail.ready) this.render(event.detail.items);
        };
        document.addEventListener('wishlist:change', this._onChange);

        const shared = window.themeWishlist;
        if (!shared) return;

        if (shared.state.ready) {
          this.render(shared.state.items);
          return;
        }

        // Paint from cache while the SDK loads.
        const cached = shared.cachedItems();
        if (cached && cached.length) this.render(cached);
      }

      disconnectedCallback() {
        document.removeEventListener('wishlist:change', this._onChange);
        document.removeEventListener('cart:change', this._onCartChange);
      }

      _showAddedBanner() {
        if (!this._addedBanner) return;

        this._addedBanner.hidden = false;
        requestAnimationFrame(() => this._addedBanner.classList.add('is-visible'));

        clearTimeout(this._addedBannerTimer);
        this._addedBannerTimer = setTimeout(() => {
          this._addedBanner.classList.remove('is-visible');
          setTimeout(() => { this._addedBanner.hidden = true; }, 200);
        }, 2500);
      }

      _show(target) {
        [this._loading, this._grid, this._empty].forEach(el => {
          if (el) el.hidden = el !== target;
        });
        if (this._toolbar) this._toolbar.hidden = target !== this._grid;
        this._shareButtons.forEach(button => { button.hidden = target !== this._grid; });

        const status = this.querySelector('[data-wishlist-status]');
        if (status && target !== this._loading) status.remove();
      }

      // Native share sheet, else clipboard copy.
      _onShareClick(event) {
        const shared = window.themeWishlist;
        if (!shared) return;

        const button = event.currentTarget;
        shared.getShareUrl((link) => {
          if (navigator.share) {
            navigator.share({ title: document.title, url: link }).catch(() => {});
            return;
          }

          navigator.clipboard.writeText(link).then(() => this._showShareCopiedLabel(button));
        }, (error) => {
          console.error('[wishlist] share failed', error);
        });
      }

      _showShareCopiedLabel(button) {
        const label = button.querySelector('[data-wishlist-share-label]');
        if (!label || !label.dataset.copiedText) return;

        const original = label.textContent;
        label.textContent = label.dataset.copiedText;
        clearTimeout(this._shareConfirmTimer);
        this._shareConfirmTimer = setTimeout(() => { label.textContent = original; }, 1500);
      }

      async render(items) {
        // Drop results from superseded renders.
        const token = (this._renderToken = (this._renderToken || 0) + 1);
        this._cards = this._cards || new Map();

        const keyOf = item => `${item.empi}:${item.epi}`;
        const wanted = new Set(items.map(keyOf));

        this._cards.forEach((card, cardKey) => {
          if (!wanted.has(cardKey)) {
            card.remove();
            this._cards.delete(cardKey);
          }
        });

        const missing = items.filter(item => !this._cards.has(keyOf(item)));
        if (missing.length) {
          const fetched = await Promise.all(missing.map(item => this._fetchCard(item)));
          if (token !== this._renderToken) return;

          missing.forEach((item, index) => {
            const card = fetched[index];
            if (!card) return;
            this._cards.set(keyOf(item), card);
            this._list.appendChild(card);
          });
        }

        if (!this._cards.size) return this._show(this._empty);
        if (this._shownCount) this._shownCount.textContent = this._cards.size;
        this._show(this._grid);
      }


      _toCard(html) {
        const template = document.createElement('template');
        template.innerHTML = (html || '').trim();
        return template.content.querySelector('product-card');
      }

      // null if the product is gone; cached cards revalidate in the background.
      async _fetchCard(item) {
        const shared = window.themeWishlist;
        const cached = shared && shared.getCachedCard(item);

        if (cached) {
          const card = this._toCard(cached);
          if (card) {
            this._revalidate(item, cached, card);
            return card;
          }
        }

        const html = await shared.fetchCardHtml(item);
        if (!html) {
          console.warn('[wishlist] skipping unavailable product', item.du);
          return null;
        }

        shared.putCachedCard(item, html);
        return this._toCard(html);
      }

      // Skip if unchanged, to preserve card interaction state.
      _revalidate(item, cachedHtml, renderedCard) {
        const shared = window.themeWishlist;

        shared.fetchCardHtml(item).then(html => {
          if (!html || html.trim() === cachedHtml.trim()) return;

          shared.putCachedCard(item, html);

          const fresh = this._toCard(html);
          if (!fresh || !renderedCard.isConnected) return;

          renderedCard.replaceWith(fresh);
          this._cards.set(`${item.empi}:${item.epi}`, fresh);
        });
      }
    });
  }
})();
